<template>
  <div class="menu-box">
    <div class="footer_top">
      <div>
        At a glance
      </div>
      <router-link to="/Contact-us" class="contant">
        <div class="Contact">
          Contact Us
          <img src="../assets/images/icon/fei.png" alt="" class="fei" />
        </div>
      </router-link>
    </div>
    <div class="menu-group">
      <ul>
        <li
          class="menu-item b-b"
          v-for="(menu, index) in menuList"
          :key="index"
          @click.stop="openSubMenu(index)"
        >
          <div class="menu-title">
            {{ menu.name }}
            <img
              src="@/assets/images/header/arrow_right.png"
              alt=""
              class="arrow_right"
              v-if="activeIndex !== index"
            />
            <img
              src="@/assets/images/header/arrow_down.png"
              alt=""
              class="arrow_right"
              v-else
            />
          </div>
          <ul class="sub-menu-group" v-show="activeIndex === index">
            <li
              class="menu-sub-item"
              v-for="(subMenu, i) in menu.children"
              :key="i"
            >
              <div
                :to="subMenu.path"
                class="link"
                @click="goPath(subMenu.path, i)"
              >
                {{ subMenu.name }}
              </div>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      activeIndex: -1,
      subActiveIndex: -1,
      menuList: [
        // {
        //   name: "Chose",
        //   children: [],
        // },
        {
          name: "About us",
          children: [
            {
              path: "/Who-we-are",
              name: "Who we are",
            },
            {
              path: "/Our-responsibility",
              name: "Our Responsibility",
            },
            {
              path: "/Why-choose-us",
              name: "Why Choose us",
            },
          ],
        },
        {
          name: "Company Strength",
          children: [
            {
              path: "/Production-capacity",
              name: "Production capacity",
            },
            {
              path: "/Research-ability",
              name: "Research ability",
            },
          ],
        },
        {
          name: "Products",
          children: [
            {
              path: "/Welding-wire",
              name: "Welding wire",
            },
            {
              path: "/cco",
              name: "CCO plate",
            },
            {
              path: "/product/Overlay-Wear-Pipe",
              name: "Overlay Wear Pipe",
            },
            {
              path: "/Wear-parts",
              name: "Wear parts",
            },
          ],
        },
        {
          name: "Applications",
          children: [
            {
              path: "/appliction/mining",
              name: "Mining",
            },
            {
              path: "/appliction/cement-plant",
              name: "Cement Plant",
            },
            {
              path: "/appliction/power-plant",
              name: "Power Plant",
            },
            {
              path: "/appliction/port",
              name: "Port",
            },
            {
              path: "/appliction/steel-mill",
              name: "Steel Mill",
            },
            {
              path: "/appliction/bulk-material-handling",
              name: "Bulk Material Handling",
            },
          ],
        },
        // {
        //   name: "News",
        //   children: [
        //     {
        //       path: "/Company-news",
        //       name: "Company News",
        //     },
        //     {
        //       path: "/Industry-news",
        //       name: "Industry News",
        //     },
        //   ],
        // },
      ],
    };
  },
  methods: {
    handShowMenuList() {
      console.log("click");
      this.show = !this.show;
    },
    openSubMenu(index) {
      if (this.activeIndex === index) {
        this.activeIndex = -1;
      } else {
        this.activeIndex = index;
      }
    },
    goPath(url, index) {
      this.$router.push(url);
      this.subActiveIndex = index;
      this.show = false;
    },
  },
};
</script>

<style lang="scss" scoped></style>

<style scoped lang="scss">
.menu-box {
  width: 100%;
  display: none;
  margin-bottom: 20px;
  @media (max-width: 768px) {
    display: block;
  }
  //   height: 100%;
  .menu-item {
    padding: 12px 0;
    color: #fff;
    font-size: 16px;
    .menu-title {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .menu-sub-item {
      padding: 10px;
      color: #fff;
      font-size: 14px;
    }
  }
}
.arrow_right {
  width: 16px;
  height: 16x;
}
.b-b {
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
}
.link {
  color: #fff;
  &.active-link {
    color: #666;
  }
}
</style>
